import { render } from "./MenuList.vue?vue&type=template&id=60cbec4c&ts=true"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__